export const LearningController = {
    index(): void {},
};
